module.exports = __webpack_public_path__ + "img/banner.d9210139.png";